/** @format */

import React, { useMemo, useState, useEffect } from 'react'
import { withRouter } from 'react-router'
import { _$, Menu, MenuItem } from '@king-design/react'
import styled from 'styled-components'
import useGlobalData from 'src/hooks/useGlobalData'
import { getSelectedMenuKey } from './menuMatch'

const RouterBar = props => {
  const productMenu = useGlobalData('productMenu')
  const path = props.location.pathname
  const selectedKey = useMemo(() => getSelectedMenuKey(path), [path])
  // 主题色
  const [theme, setTheme] = useState<'light' | 'dark' | 'white'>('light')
  // 展开菜单
  const [expandedKeys, setexpandedKeys] = useState<string[]>([
    '/monitor/prometheusmonitor/instanceList'
  ])

  useEffect(() => {
    let windowRegion
    window['__ksStorage__']?.on('theme', data => {
      setTheme(data)
    })
    return () => {
      windowRegion && windowRegion.remove()
    }
  }, [])

  return (
    <div className={props.className}>
      {productMenu?.length ? (
        <Menu
          size="small"
          slotHeader={<>{_$('云监控')}</>}
          onChangeCollapse={val => {
            props.setMenuState(val)
          }}
          expandedKeys={expandedKeys}
          onChangeExpandedKeys={expandedKeys => {
            setexpandedKeys(expandedKeys)
          }}
          selectedKey={selectedKey}
          collapse={props.menuState}
          showCollapseArrow={true}
          theme={theme}
        >
          <MenuItem key="/monitor/generalview/home" to="/monitor/generalview/home">
            {_$('概览')}
          </MenuItem>
          <MenuItem key="/monitor/menu" to="/monitor/menu">
            {_$('云产品监控')}
          </MenuItem>
          <MenuItem key="1">
            {_$('Prometheus监控')}
            <Menu>
              <MenuItem
                key="/monitor/prometheusmonitor/instanceList"
                to="/monitor/prometheusmonitor/instanceList"
              >
                {_$('实例列表')}
              </MenuItem>
              <MenuItem
                key="/monitor/prometheusmonitor/metricexplore"
                to="/monitor/prometheusmonitor/metricexplore"
              >
                {_$('指标探索')}
              </MenuItem>
              <MenuItem
                key="/monitor/prometheusmonitor/alarm"
                to="/monitor/prometheusmonitor/alarm"
              >
                {_$('告警管理')}
              </MenuItem>
            </Menu>
          </MenuItem>
          <MenuItem key="2">
            {_$('Grafana服务')}
            <Menu>
              <MenuItem key="/monitor/grafana/instancelist" to="/monitor/grafana/instancelist">
                {_$('实例信息')}
              </MenuItem>
            </Menu>
          </MenuItem>
          <MenuItem key="3">
            {_$('AI可观测')}
            <Menu>
              <MenuItem
                key="/monitor/aiobservability/serviceoverview"
                to="/monitor/aiobservability/serviceoverview"
              >
                {_$('服务总览')}
              </MenuItem>
              <MenuItem
                key="/monitor/aiobservability/sessionanalysis"
                to="/monitor/aiobservability/sessionanalysis"
              >
                {_$('会话分析')}
              </MenuItem>
              <MenuItem
                key="/monitor/aiobservability/traceanalysis"
                to="/monitor/aiobservability/traceanalysis"
              >
                {_$('Trace分析')}
              </MenuItem>
              <MenuItem
                key="/monitor/aiobservability/accesscenter"
                to="/monitor/aiobservability/accesscenter"
              >
                {_$('接入中心')}
              </MenuItem>
            </Menu>
          </MenuItem>
          <MenuItem key="4">
            {_$('告警服务')}
            <Menu>
              <MenuItem key="/monitor/alarmServer/rule/home" to="/monitor/alarmServer/rule/home">
                {_$('告警策略')}
              </MenuItem>
              <MenuItem
                key="/monitor/alarmServer/history/home"
                to="/monitor/alarmServer/history/home"
              >
                {_$('告警历史')}
              </MenuItem>
              <MenuItem
                key="/monitor/alarmServer/alarming/home"
                to="/monitor/alarmServer/alarming/home"
              >
                {_$('正在告警')}
              </MenuItem>
              <MenuItem
                key="/monitor/alarmServer/template/home"
                to="/monitor/alarmServer/template/home"
              >
                {_$('触发条件模版')}
              </MenuItem>
              <MenuItem
                key="/monitor/alarmServer/silences/home"
                to="/monitor/alarmServer/silences/home"
              >
                {_$('告警屏蔽')}
              </MenuItem>
              <MenuItem
                key="/monitor/alarmServer/alertTarget"
                to="/monitor/alarmServer/alertTarget"
              >
                {_$('通知对象')}
              </MenuItem>
            </Menu>
          </MenuItem>
          <MenuItem key="5">
            {_$('自定义监控')}
            <Menu>
              <MenuItem key="/monitor/custom/metric" to="/monitor/custom/metric">
                {_$('指标')}
              </MenuItem>
              <MenuItem key="/monitor/custom/alarm" to="/monitor/custom/alarm">
                {_$('警报')}
              </MenuItem>{' '}
            </Menu>
          </MenuItem>
          <MenuItem key="6">
            {_$('自动化运维')}
            <Menu>
              <MenuItem key="/monitor/eventops/trigger" to="/monitor/eventops/trigger">
                {_$('触发器')}
              </MenuItem>
              <MenuItem key="/monitor/eventops/scene" to="/monitor/eventops/scene">
                {_$('自动化场景')}
              </MenuItem>
              <MenuItem key="/monitor/eventops/record" to="/monitor/eventops/record">
                {_$('执行记录')}
              </MenuItem>
              <MenuItem key="/monitor/eventops/functions" to="/monitor/eventops/functions">
                {_$('公共函数')}
              </MenuItem>
            </Menu>
          </MenuItem>
          <MenuItem key="/monitor/systomcenter/home" to="/monitor/systomcenter/home">
            {_$('事件中心')}
          </MenuItem>
          <MenuItem key="/monitor/dashboard/home" to="/monitor/dashboard/home">
            {_$('Dashboard')}
          </MenuItem>
          <MenuItem key="/monitor/group/home" to="/monitor/group/home">
            {_$('资源分组')}
          </MenuItem>
        </Menu>
      ) : null}
    </div>
  )
}
const SiderBar = withRouter(RouterBar)
export default styled(SiderBar)`
  padding-top: 50px;
  position: fixed;
  top: 0;
  height: 100vh;
  background: #fff;
  z-index: 99;
  .divider-style {
    margin: 4px 0;
  }
`
